import { Box, SxProps, Theme } from '@mui/material';
import VoteMateLogo from '../../ui-library/VoteMateLogo';
import VoteMateTextLogo from '../../ui-library/VoteMateTextLogo';

export const VotemateLogo: React.FC<{
  size?: number;
  logoOnly?: boolean;
  textFill?: string;
  sx?: SxProps<Theme>;
}> = ({ size = 32, logoOnly = false, textFill, sx }) => {
  // If only logo is requested
  if (logoOnly) {
    return <VoteMateLogo size={size} />;
  }

  // Default: show both logo and text — label the wrapper, suppress child labels
  return (
    <Box
      role="img"
      // Intentionally left untranslated: "VoteMate" is the brand name and
      // stays literal across all locales (see issue #2077, E3).
      aria-label="VoteMate"
      sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}
    >
      <VoteMateLogo size={size} aria-hidden />
      <Box sx={{ marginTop: 0.1 }}>
        <VoteMateTextLogo size={size * 0.6} fill={textFill} aria-hidden />
      </Box>
    </Box>
  );
};
